module.exports = __webpack_public_path__ + "img/energy.543014c1.png";